import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import Routes from './common/Routes';

type O365InputConfigurationProps = {
  url?: string;
};

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const O365InputConfiguration = ({ url = Routes.INTEGRATIONS.O365.ACTIVITYAPI.index }: O365InputConfigurationProps) => {
  const history = useHistory();

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

export default O365InputConfiguration;
